<div class="page-header-container">
  <h1 class="page-header-title">{{ 'COMMON.INFORMATION' | translate }}</h1>
  <mat-divider></mat-divider>
  <div class="grid">
    @for (field of fields(); track field.key) {
      <md-info-block [title]="field.labelKey | translate" [text]="getFieldValue(field)"> </md-info-block>
    }
  </div>
  @if (pricingRoute()) {
    <a class="plain-link" [routerLink]="pricingRoute()">{{ pricingRouteLabel() | translate }}</a>
  }
  <md-other-integrations-info [integrationsItem]="item()"></md-other-integrations-info>
</div>
